<template>
<div id="label-profile" class="">
    <!-- show share info only for owner -->
    <InfoPopup v-if="isOwnProfile" :uid="uid" :is-own-profile="isOwnProfile" />

    <div class="bg-containter bc-black d-f fd-c">

        <!-- Ticker -->
        <div class="ticker w-100 d-f jc-c" v-show="!loading">
            <TickerText :key="marqueeKey" :repeat="12" :paused="false" :pause-on-hover="false">
                <h1 class="ws-pre tt-up text-outline">
                    <!-- <span v-if="reformatLocations && reformatLocations.length">
                    <span class="m-r" v-for="(loc, i) in reformatLocations" :key="i">
                        {{ loc }}
                    </span>
                    </span>
                    <span v-else>Unranked label </span> -->
                    <span v-if="getGenres && getGenres.length">
                      <span
                          v-for="(genre, i) in getGenres"
                          :key="i"
                          class="m-r"
                      >{{ genre }}</span>
                    </span>
                      <!-- <a
                          v-for="(genre, i) in getGenres"
                          :key="i"
                          @click.prevent=""
                          href="#"
                          class="m-r"
                      >{{ genre }}</a> -->
                  <span class="o-5" v-else></span>

                </h1>
            </TickerText>
        </div>

        <!-- Col Wrap -->
        <div class="col-wrap1 d-f grey tt-up p-l p-r g ai-fe jc-fe">
            <div class="col-1 d-f flex-1">
                <p class="grey hide-mob">{{ labelData.labelName }}</p>
            </div>
            <div class="col-2 d-f flex-1">
                <p class="hide-mob">Links</p>
            </div>
            <div class="col-3 d-f flex-1">
                <router-link
                  v-if="isOwnProfile"
                  to="/settings"
                  class="profile-img d-f jc-c ai-c img-big p-a pointer"
                >
                    <img 
                        class="b-r-100 bc-black" 
                        v-if="labelData.logo" 
                        :src="labelData.logo" 
                        alt="Logo"
                    />
                    <div v-else><PlaceholderImg /></div>
                </router-link>
                <div v-else class="profile-img d-f jc-c ai-c img-big p-a">
                    <img 
                        class="b-r-100 bc-black" 
                        v-if="labelData.logo" 
                        :src="labelData.logo" 
                        alt="Logo"
                    />
                    <div v-else><PlaceholderImg /></div>
                </div>
            </div>
            <div class="col-4 d-f flex-1 jc-fe">
                <p class="hide-mob">Genres</p>
            </div>
            <div class="col-5 d-f flex-1 jc-fe">
                <p class="hide-mob">Location</p>
            </div>
        </div>

    </div>

    <!-- Info Wrap Desktop -->
    <div class="info-wrap-desktop d-f fd-c ai-c hide-mob">
      <div class="col-wrap2 d-f tt-up p-l p-r g w-100 bs-bb">
          <div class="col-1 d-f flex-1 fd-c">
              <p class="grey hide-desk">{{ labelData.labelName }}</p>
              <div class="d-f fd-c">
                  <a v-if="!isOwnProfile" @click="follow"
                  >{{ isFollowing ? "Unfollow" : "Follow" }}
                  <span class="grey">{{ isFollowing ? "-1" : "+1" }}</span></a
                  >
                  <a @click="$emit('openUsersList', { followers })">
                  Followers <span class="grey">{{ followers.length }}</span>
                  </a>
                  <a @click="$emit('openUsersList', { followings })">
                  Following <span class="grey">{{ followings.length }}</span>
                  </a>
              </div>  
          </div>
          <div class="col-2 d-f flex-1 fd-c">
              <p class="hide-desk">Links</p>
              <div class="d-f fd-c" v-if="getLinks && getLinks.length">
              <div class="d-f fd-c" v-for="(link, i) in getLinks" :key="i">
                  <a :href="normalizeLinkUrl(link.url)" target="_blank">{{ link.title }}</a>
              </div>
              </div>
              <div class="d-f fd-c o-5" v-else><p>—</p></div>
          </div>
          <div class="col-3 d-f flex-1">
            <div class="divider hide-desk"></div>
          </div>
          <div class="col-4 d-f flex-1 fd-c ai-fe">
              <p class="hide-desk">Genres</p>
              <div v-if="getGenres && getGenres.length" class="d-f fd-c ai-fe">
                <p class="genres ta-r" v-for="(genre, i) in getGenres" :key="i">
                  <router-link :to="{ path: `music/genre-${genre}` }">
                  {{ genre }}
                  </router-link>
                </p>
              </div>
              <p class="ta-r o-5" v-else>—</p>
          </div>
          <div class="col-5 d-f flex-1 fd-c ai-fe">
            <p class="hide-desk">Location</p>
            <div v-if="reformatLocations && reformatLocations.length">
                <div
                class="d-f fd-c ai-fe"
                v-for="(loc, i) in reformatLocations"
                :key="i"
                >
                <div class="ta-r">{{ loc }}</div>
                </div>
            </div>
            <div class="d-f fd-c o-5" v-else><p>—</p></div>
          </div>
      </div>
      <!-- Title Wrap -->
      <div class="title-wrap d-f fd-c ai-c jc-c w-100 p-t-lg p-b-sm bs-bb">
          <h3>{{ labelData.labelName }}</h3>    
      </div>

    <!-- Description Toggle -->
    <div class="description-toggle m-b-lg ta-c">
      <div
        v-if="labelData.description && labelData.description.trim()"
        class="d-f fd-c ai-c jc-c g pointer small-wrap"
        @click="isDescriptionExpanded = !isDescriptionExpanded"
      >
        <p class="m-0">
          {{
            isDescriptionExpanded
              ? labelData.description
              : labelData.shortDescription
          }}
        </p>
        <p
          class="text-link font-small mute tt-up"
          v-if="isDescriptionExpanded"
        >
          Read less
        </p>
        <p class="text-link font-small mute tt-up" v-else>Read more</p>
      </div>
      <p v-else class="m-0">{{ labelData.shortDescription }}</p>
    </div>

    </div>

    <!-- Info Wrap Mobile -->
    <div class="info-wrap-mobile d-f fd-c ai-c hide-desk">
      <!-- Title Wrap -->
      <div class="title-wrap d-f fd-c ai-c jc-c w-100 p-t-lg bs-bb">
          <h3>{{ labelData.labelName }}</h3>    
      </div>

    <!-- Description Toggle -->
    <div class="description-toggle p-b-lg p-t-sm p-l p-r bs-bb ta-c" style="max-width: 300px;">
      <div
        v-if="labelData.description && labelData.description.trim()"
        class="d-f fd-c ai-c jc-c g pointer small-wrap"
        @click="isDescriptionExpanded = !isDescriptionExpanded"
      >
        <p class="m-0">
          {{
            isDescriptionExpanded
              ? labelData.description
              : labelData.shortDescription
          }}
        </p>
        <p
          class="text-link font-small mute tt-up"
          v-if="isDescriptionExpanded"
        >
          Read less
        </p>
        <p class="text-link font-small mute tt-up" v-else>Read more</p>
      </div>
      <p v-else class="m-0">{{ labelData.shortDescription }}</p>
    </div>

      <div class="col-wrap2 d-f grey tt-up p-l p-r g w-100 bs-bb p-b-lg">
        <div class="col-inner-left d-f fd-c flex-1">
          <div class="col-1 d-f fd-c">
              <p class="grey">{{ labelData.labelName }}</p>
              <div class="d-f fd-c">
                  <a v-if="!isOwnProfile" @click="follow"
                  >{{ isFollowing ? "Unfollow" : "Follow" }}
                  <span class="grey">{{ isFollowing ? "-1" : "+1" }}</span></a
                  >
                  <a @click="$emit('openUsersList', { followers })">
                  Followers <span class="grey">{{ followers.length }}</span>
                  </a>
                  <a @click="$emit('openUsersList', { followings })">
                  Following <span class="grey">{{ followings.length }}</span>
                  </a>
              </div>  
          </div>
          <div class="col-2 d-f fd-c">
              <p>Links</p>
              <div class="d-f fd-c" v-if="getLinks && getLinks.length">
                <div class="d-f fd-c" v-for="(link, i) in getLinks" :key="i">
                    <a :href="normalizeLinkUrl(link.url)" target="_blank">{{ link.title }}</a>
                </div>
              </div>
              <div class="d-f fd-c o-5" v-else><p>—</p></div>
          </div>
        </div>
          <div class="col-3 d-f">
            <div class="divider"></div>
          </div>
        <div class="col-inner-right d-f fd-c ai-fe flex-1">
          <div class="col-4 d-f fd-c ai-fe">
              <p>Genres</p>
              <div v-if="getGenres && getGenres.length" class="d-f fd-c ai-fe">
                <p class="genres ta-r" v-for="(genre, i) in getGenres" :key="i">
                  <router-link :to="{ path: `music/genre-${genre}` }">
                  {{ genre }}
                  </router-link>
                </p>
              </div>
              <p class="ta-r o-5" v-else>—</p>
          </div>
          <div class="col-5 d-f fd-c ai-fe">
            <p>Location</p>
            <div v-if="reformatLocations && reformatLocations.length">
                <div
                class="d-f fd-c ai-fe"
                v-for="(loc, i) in reformatLocations"
                :key="i"
                >
                <div class="ta-r">{{ loc }}</div>
                </div>
            </div>
            <div class="d-f fd-c 0-5" v-else><p>—</p></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Submit Demo Card -->
    <div class="d-f fd-c ai-c p-hor">
      <SubmitDemoCard
        v-if="labelData.acceptingSubmissions"
        :label-uid="uid"
        :label-data="labelData"
        :demo-criteria="labelData.demoCriteria"
      />
    </div>

    <!-- Songs Playlist -->
    <div class="d-f fd-c ai-c">
        <SongsPlaylistProfile
            :playlist-position="0"
            @play-select-song="playSelectedSongAsync"
            :playlist="uploadsList"
            :type="'label'"
            :is-own-profile="isOwnProfile"
        >
        </SongsPlaylistProfile>
    </div>

    <!-- Events -->
    <div class="d-f fd-c ai-c">
      <EventsSection v-if="uid" :user-id="uid" />
    </div>

</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PlayerMixin from "@/mixins/PlayerMixin";
import { isMobileMixin } from "@/mixins/isMobileMixin";
import SongsPlaylistProfile from "@/components/profile/SongsPlaylistProfile";
import TickerText from "@/components/misc/TickerText.vue";
import PlaceholderImg from "@/assets/icons/PlaceholderImg.vue";
import SubmitDemoCard from "@/components/demos/SubmitDemoCard.vue";
import InfoPopup from "@/components/misc/InfoPopup.vue";
import EventsSection from "@/components/profile/EventsSection.vue";
import { rtdb } from "@/db";

export default {
  name: "LabelProfile2",
  props: {
    /**
     * @type {labelSettings}
     */
    labelData: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    isOwnProfile: {
      type: Boolean,
      default: false,
    },
    uid: {
      type: String,
      required: true,
    },
  },
  components: {
    SongsPlaylistProfile,
    TickerText,
    PlaceholderImg,
    SubmitDemoCard,
    InfoPopup,
    EventsSection,
  },
  mixins: [PlayerMixin, isMobileMixin],
  data() {
    return {
      uploadsList: {
        title: "Profile music jahdkjwah",
        songs: null,
      },
      marqueeKey: 0, // Key to force reinitialization
      isDescriptionExpanded: false,
    };
  },
  mounted() {
    this.getUploads();
    this.$nextTick(() => {
      this.marqueeKey++; // Force reinitialization after DOM is updated
    });
  },
  computed: {
    ...mapGetters(["getUser", "getUserSettings", "getPlayerHidden"]),
    getLinks() {
      return this.labelData.externalLinks;
    },
    getGenres() {
      if (this.labelData && this.labelData.genres) {
        if (typeof this.labelData.genres === 'string') {
          return this.labelData.genres.split(',').map(g => g.trim()).filter(g => g);
        } else if (Array.isArray(this.labelData.genres)) {
          return this.labelData.genres.filter(g => g && g.trim());
        }
      }
      return false;
    },
    reformatLocations() {
      if (this.labelData && this.labelData.location) {
        return this.labelData.location.split(",").map((loc) => loc.trim()).filter(loc => loc);
      }
      return [];
    },
    followers() {
      if (!this.labelData) return [];
      return Object.entries(this.labelData.followers || {})
        .map(([key, value]) => {
          return value && key;
        })
        .filter(Boolean);
    },
    followings() {
      if (!this.labelData) return [];
      return Object.entries(this.labelData.followings || {})
        .map(([key, value]) => {
          return value && key;
        })
        .filter(Boolean);
    },
    isFollowing() {
      return (
        this.getUser.data?.uid && this.followers.includes(this.getUser.data.uid)
      );
    },
  },
  methods: {
    ...mapActions(["addPlaylist", "replacePlaylist", "followUser"]),

    playSelectedSongAsync(payload, playlist) {
      const that = this;
      async function asyncFunc() {
        await that.replacePlaylist({
          title: "Teeeeeesting",
          songs: that.uploadsList.songs,
        });
        that.playSelectedSong(payload);
        console.log(payload);
      }
      return asyncFunc();
    },

    getUploads() {
      const userUid = this.uid;
      const usersMusicRef = rtdb.ref(`userMusic/${userUid}`);
      usersMusicRef.on("value", (snapshot) => {
        const arr = [];
        snapshot.forEach((x) => {
          const val = x.val() || {};
          arr.push({
            ...val,
            songUid: val.songUid || x.key,
            userUid: val.userUid || userUid,
          });
        });
        this.$set(this.uploadsList, "songs", arr);
      });
    },

    normalizeLinkUrl(url) {
      if (!url || typeof url !== "string") return "#";
      const trimmed = url.trim();
      if (!trimmed) return "#";
      if (/^https?:\/\//i.test(trimmed)) return trimmed;
      return `https://${trimmed}`;
    },

    follow() {
      const wasFollowing = this.isFollowing;
      this.followUser({
        uid: this.uid,
        type: "label",
        status: !wasFollowing,
      });
      const message = wasFollowing 
        ? "Unfollowed profile" 
        : "Following profile";
      this.$store.dispatch("togglePopMess", message);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/scss/_variables.scss";
@import "@/scss/_classes.scss";
@import "@/scss/_mixins.scss";
#label-profile {
  .bg-containter {
    height: 50vh;
    justify-content: flex-end;
    position: relative;
    overflow: visible;
    .col-wrap1 {
      .col-1, .col-2, .col-4, .col-5 {
          padding-bottom: calc($mg-desktop / 2);
      }
      .col-3 {
      //This is to center the profile image in the column-3
        position: relative;
        display: flex;
        justify-content: center;
        .profile-img {
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translate(-50%, 50%);
          z-index: 10;
        }
      }
    }
  }
  .info-wrap-desktop {
    .col-wrap2 {
      padding-top: calc($mg-desktop / 2);
      min-height: calc($img-l-d / 2);
      @media #{$mobile} {
        margin-top: calc($img-l-m / 2);
      }
    }
  }
  .info-wrap-mobile {
    margin-top: calc($img-l-m / 2);
    .col-wrap2 {
      padding-top: calc($mg-mobile / 2);
      min-height: calc($img-l-m / 2);
      .divider {
          width: 1px;
          height: 100%;
          background-color: $line-color;
      }   
      .col-1, .col-4 {
          padding-bottom: $mg-mobile;
      }
    }
  }
  .playermargin {
    margin-bottom: 70px;
  }
  .ticker {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    transform: translateY(-50%);
    z-index: 0;
    // TickerText component handles overflow and animation
    h1 {
      padding: 20px 0;
      display: inline-block;
      @media #{$mobile} {
        font-size: $h1-xl-m;
      }
    }
  }
}
</style>

